// extracted by mini-css-extract-plugin
export var active = "modal-module--active--ef8a6";
export var big = "modal-module--big--56a3a";
export var bigSearch = "modal-module--bigSearch--5e080";
export var close = "modal-module--close--1b5c8";
export var closeCancelSearch = "modal-module--closeCancelSearch--e7711";
export var heightChange = "modal-module--heightChange--c7f2d";
export var line = "modal-module--line--ec95a";
export var modal = "modal-module--modal--93a82";
export var nolineSearch = "modal-module--nolineSearch--6f36c";
export var overlay = "modal-module--overlay--47fd1";
export var thick = "modal-module--thick--6185c";
export var timesIcon = "modal-module--timesIcon--cc60e";
export var wrapper = "modal-module--wrapper--a3bdb";